import { Box, Grid2, Icon, IconButton, Paper, SxProps, Theme, Typography } from "@mui/material";
import { ButtonIconType, ButtonVariant } from "../button/primary.button";
import { IListItemButton } from "../../_common/interface/buttons/iListItemButton.interface";


export function StandardListItem(params: {
    sx?: SxProps<Theme>,
    key: string,
    primary: string,
    secondary?: React.ReactNode,
    tertiary?: React.ReactNode,
    buttons?: Array<IListItemButton>

}) {
    return (
        <Grid2 size={{ xs: 12 }} key={params.primary + "_" + params.key}>
            <Paper
                elevation={1}
                sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: 0,
                    backgroundColor: '#f9f9f9', //Red background for public Actions
                    '&:hover': {
                        backgroundColor: '#f1f1f1', //Red background for public Actions
                    },
                    ...params.sx,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                    <Typography variant="body1" mr={2}> {params.primary}</Typography>
                </Box>
                {!!params.secondary &&
                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                        <Typography variant="body1" mr={2}> {params.secondary}</Typography>
                    </Box>
                }
                {!!params.tertiary &&
                    <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
                        <Typography variant="body1" mr={2}> {params.tertiary}</Typography>
                    </Box>
                }
                {(!!params.buttons && !!params.buttons.length) && params.buttons.filter(m => m.display !== false).map((b, index) =>
                    <IconButton disabled={b.disabled} onClick={(e) => { b.onClick(e, index) }} color={b.variant || "primary"}>
                        <Icon>{b.icon}</Icon>
                    </IconButton>
                )}
            </Paper>
        </Grid2>
    )
}